function CurrentPensionChart() {
  this.chart = function (chartSelector, estimatedPension, currentSalary) {
    new Chartist.Pie(chartSelector, {
      series: [
        {
          value: estimatedPension.firstPillar.monthlyAmount,
          className: 'pillar-1-pie-section',
        },
        {
          value: estimatedPension.secondPillar.monthlyAmount,
          className: 'pillar-2-pie-section',
        },
        {
          value: estimatedPension.thirdPillar.monthlyAmount,
          className: 'pillar-3-pie-section',
        },
        {
          value: Math.max(currentSalary - estimatedPension.total, 0),
          className: 'current-salary-pie-section',
        }
      ]
    }, {
      donut: true,
      donutWidth: 20,
      donutSolid: true,
      startAngle: 0,
      total: Math.max(currentSalary, estimatedPension.total),
      showLabel: false
    });
  }
}